import { useDripsyTheme } from 'dripsy'

export default function useTheme() {
  // return (useDripsyTheme().theme as any) as DripsyTheme
  return useDripsyTheme().theme
}
